<template>
  <div class="atividades-sacsolicitacoes ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->

        <b-col cols="3">
          <label for="select-garagem_sol">Filial</label>
          <multiselect
            id="selecao-filial-sol"
            v-model="value_filial"
            required
            :options="filiais"
            :multiple="true"
            :taggable="true"
            @close="loadLote()"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Selecione a filial"
            label="filial"
            track-by="filial"
            name="filial"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Filial selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="3">
          <label for="select-status">Status</label>

          <multiselect
            id="selecao-status-sol"
            v-model="value_status"
            required
            :options="statuss"
            :multiple="true"
            :taggable="true"
            @tag="addTag"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Status"
            label="status"
            track-by="status"
            name="status"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} status selecionado</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="1">
          <br />
          <b-button
            variant="primary"
            class="mr-2 mt-2"
            @click="getAgendaFuncionario()"
            block
          >
            Carregar
          </b-button>
        </b-col>

        <b-col cols="5" class="mb-0">
          <label for="input-busca">Pesquisa no grid </label>
          <b-form-input
            id="buscamonitoramento"
            v-model="search"
            required="required"
            placeholder="Registro ou Tipo de solicitação ou palavras na solicitação"
          ></b-form-input>
        </b-col>

        <!-- condicional para exibir o botão planilha-->

        <b-col cols="2" v-if="user.id_empresa == 18">
          <br />
          <b-button
            variant="primary"
            class="mr-2 mt-2"
            @click="reset(), loadDepartamentos()"
            v-b-modal.modal-multi-2
            block
          >
            Novo
          </b-button>
        </b-col>
      </b-row>
    </b-form>

    <LoadingModal v-if="isLoading" />

    <b-col>
      <div>
        <b-progress class="mt-3 mp-3" :max="barra_limite">
          <b-progress-bar
            variant="success"
            :value="barra_inicial"
            :label="`${((barra_inicial / barra_limite) * 100).toFixed(2)} %`"
          ></b-progress-bar>
        </b-progress>
      </div>
    </b-col>

    <b-row>
      <b-col cols="3" class="mt-3">
        <b-card
          class="ml-2"
          style="width: 33rem"
          border-variant="primary"
          header="AGENDAMENTO CANCELADO"
          header-bg-variant="danger"
          header-text-variant="white"
          align="center"
        >
          <b-card-text>
            <h2>
              {{ itemsFiltered.filter((s) => s.status === "CANCELADO").length }}
            </h2>
          </b-card-text>
        </b-card>
      </b-col>

      <b-col cols="3" class="mt-3">
        <b-card
          class="mr-2"
          style="width: 33rem"
          border-variant="primary"
          header="AGENDAMENTO PENDENTES"
          header-bg-variant="warning"
          header-text-variant="white"
          align="center"
        >
          <b-card-text>
            <h2>
              {{ itemsFiltered.filter((s) => s.status === "AGENDADO").length }}
            </h2>
          </b-card-text>
        </b-card>
      </b-col>

      <b-col cols="3" class="mt-3">
        <b-card
          class="mr-2"
          style="width: 33rem"
          border-variant="primary"
          header="AGENDAMENTO ATENDIDOS"
          header-bg-variant="success"
          header-text-variant="white"
          align="center"
        >
          <b-card-text>
            <h2>
              {{ itemsFiltered.filter((s) => s.status === "ATENDIDO").length }}
            </h2>
          </b-card-text>
        </b-card>
      </b-col>

      <b-col cols="3" class="mt-3">
        <b-card
          class="ml-2"
          style="width: 33rem"
          border-variant="primary"
          header="TOTAL SOLICITAÇÕES "
          header-bg-variant="primary"
          header-text-variant="white"
          align="center"
        >
          <b-card-text>
            <h2>
              {{ itemsFiltered.length }}
            </h2>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>

    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>
    <!--tbl de dados -->
    <b-table
      id="agendamento"
      small
      hover
      striped
      sticky-header="756px"
      :items="itemsFiltered"
      :fields="fieldsSolicitado"
    >
      <template slot="cell(actions)" slot-scope="data">
        <b-button
          @click="
            loadCarregaSac(data.item),
              loadDepartamentos(),
              loadFuncionario(),
              loadStatus()
          "
          title="Editar agendamento"
          size="sm"
          variant="primary"
          class="mr-2 mt-2"
          v-b-modal.modal-multi-2
        >
          <i class="fa fa-exclamation-circle"></i>
        </b-button>
      </template>
    </b-table>

    <!--  MODAL SOLICITÇÕES  -->
    <div>
      <b-modal
        id="modal-multi-2"
        cancel-title="Fechar"
        ok-title="Gravar"
        @ok="postAgendaFuncionario()"
        size="xl"
        :title="`Agendamento Nº.: ${
          sacAgendamento.id != null ? sacAgendamento.id : '-'
        }`"
        no-close-on-esc
        no-close-on-backdrop
      >
        <!-- ,postSacTratativa(),putSacTratativa(),postNotificacao() -->
        <div>
          <!--            <b-row v-if="sacAgendamento.id_Agendamento !=='' && sacAgendamento.id_Agendamento !== null"> -->
          <b-row>
            <input
              id="id-sac"
              type="hidden"
              v-model="sacAgendamento.id_Agendamento"
            />

            <b-col cols="1" class="mt-2 pr-4">
              <b-form-group label="" label-for="tabela-foto">
                <b-img
                  height="120"
                  width="78"
                  class="mb-5"
                  v-model="sacAgendamento.logo"
                  v-bind="mainProps"
                  rounded
                  alt="Foto"
                  :src="sacAgendamento.logo"
                >
                </b-img>
              </b-form-group>
            </b-col>

            <b-col cols="2" class="mt-5">
              <label for="input-live">Registro</label>
              <b-form-input
                id="resolicitante"
                v-model="sacAgendamento.solicitante_re"
                @keyup.enter="loadFuncionario()"
                placeholder=""
                class="mb-3"
              ></b-form-input>
            </b-col>

            <b-col cols="4" class="mt-5">
              <label for="input-live">Nome</label>
              <b-input-group-text>
                {{
                  sacAgendamento.nome
                    ? sacAgendamento.nome
                    : funcionarios.length > 0
                    ? funcionarios[0].nome_completo
                    : "-"
                }}
              </b-input-group-text>
            </b-col>

            <b-col cols="4" class="mt-5">
              <label for="input-live">Função</label>
              <b-input-group-text>
                {{
                  sacAgendamento.funcao
                    ? sacAgendamento.funcao
                    : funcionarios.length > 0
                    ? funcionarios[0].funcao
                    : "-"
                }}
              </b-input-group-text>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="9" sm="4" class="mt-1">
              <label for="input-parecer">Departamento</label>
              <div>
                <b-form-select
                  id="infoFormato"
                  v-model="sacAgendamento.depto_id"
                  :options="departamentos"
                  class="mb-3"
                  text-field="area"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="3">
              <div>
                <label for="datepicker-placeholder">Data agendamento</label>
                <b-form-datepicker
                  id="dt_sol_inicial"
                  required
                  v-model="sacAgendamento.dt_agendado"
                  @input="loadHorarioAgenda()"
                  placeholder="Data inicial "
                  locale="pt-BR"
                  date-format-options="DD/MM/YYYY"
                ></b-form-datepicker>
              </div>
            </b-col>

            <b-col cols="9" sm="4" class="mt-1" v-if="sacAgendamento.id">
              <label for="input-parecer">Status</label>
              <div>
                <b-form-select
                  id="infoFormato"
                  v-model="sacAgendamento.status_id"
                  :options="statuss"
                  class="mb-3"
                  text-field="status"
                >
                </b-form-select>
              </div>
            </b-col>

            <!--
              <b-col cols="2">
                <br>                 
                <b-button  variant="success" class="mr-2 mt-2" @click="loadHorarioAgenda()" block>
                   Carregar horário
                </b-button>                      
              </b-col>
-->
          </b-row>

          <b-row>
            <b-col sm="12">
              <label for="textarea-small">Observação do solicitante</label>
            </b-col>

            <b-col cols="12">
              <b-form-textarea
                id="id-obs"
                v-model="sacAgendamento.observacao"
                placeholder="Observação"
              ></b-form-textarea>
            </b-col>
          </b-row>

          <!-- Tratativas -->
          <div class="d-flex justify-content-center mb-3">
            <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
          </div>
          <!--tbl de dados -->

          <b-row>
            <b-col sm="12">
              <label for="textarea-small">Parecer da solicitação:</label>
            </b-col>

            <b-col cols="12">
              <b-form-textarea
                id="id-obs"
                v-model="sacAgendamento.parecer"
                size="sm"
                placeholder="Digite o parecer"
              ></b-form-textarea>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="10" class="mt-2" v-if="sacAgendamento.id_status == 3">
              <label for="textarea-small">Avaliação do atendimento:</label>
              <b-form-rating
                v-model="sacAgendamento.avaliacao"
                @change="uptAvaliacao()"
              ></b-form-rating>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="mb-3 mt-3 ml-5">
              <div>
                <b-img
                  v-if="sacAgendamento.file === 'true'"
                  :src="sacAgendamento.file"
                  width="600"
                  height="600"
                ></b-img>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-modal>
    </div>
    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->

    <div>
      <b-modal
        id="modal-AgendamentoFotos"
        hide-footer
        size="lg"
        :title="`Fotos da solicitação: ${sacAgendamento.id_Agendamento}`"
        no-close-on-backdrop
      >
        <div class="d-flex justify-content-center" style="height: 80vh">
          <b-carousel
            id="carouselFoto"
            class="carouselFoto"
            v-model="slide"
            :interval="4000"
            controls
            indicators
            background="#ababab"
            style="text-shadow: 1px 1px 2px #333"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
          >
            <b-carousel-slide
              v-for="item in Agendamento"
              :key="item.id"
              :img-src="item.foto_thumbnail"
            ></b-carousel-slide>
          </b-carousel>
        </div>
      </b-modal>
    </div>
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment, { now } from "moment";
import { mapState } from "vuex";
import * as XLSX from "xlsx";
import LoadingModal from "../utilitarios/LoadingModal";

export default {
  name: "SacAtendamentos",

  computed: {
    ...mapState(["user"]),

    itemsFiltered() {
      // Se a busca estiver vazia, retorne todos os agendamentos
      if (!this.search) {
        return this.sacAgendamentos;
      }

      // Filtrar os itens com base na pesquisa
      return this.sacAgendamentos.filter((item) => {
        return (
          (item.solicitante_re &&
            item.solicitante_re.indexOf(this.search) > -1) ||
          (item.departamento && item.departamento.indexOf(this.search) > -1) ||
          (item.observacao && item.observacao.indexOf(this.search) > -1)
        );
      });
    },
  },

  data: function () {
    return {
      sacAgendamento: {},
      sacAgendamentos: [],
      sacAgendamentoHorarios: [],
      sacAgendamento: {}, // [] lista
      funcionarios: [],
      sacsolicitacoes: [], // [] lista
      pedidoferias: [], // implantado 08/07/2023
      sacT: {}, // [] lista
      sacsolicitacoestratativa: [], // [] lista
      search: "",
      departamentos: [],
      assuntos: [],
      motivos: [],
      idRetornoAgendamento: [],
      Agendamento: [],

      mode: "save",
      carregando: false,
      atualizando: false,
      isLoading: false,
      empresa: {},
      empresas: [], // [] lista
      value_empresa: [], // [this.empresas],
      value_filial: [],
      value_status: [],
      filial: {},
      filiais: [], // [] lista
      //value_filial:[],// [] lista

      status: {},
      statuss: [], // [] lista

      permissoes: [],
      permissao: {},

      value_id_area: "",
      barra_inicial: 0,
      barra_limite: 60000 * 5, // temporizador 60.000 milisegundos refere-se a 1 minutos

      fieldsSolicitado: [
        {
          key: "dt_agendado",
          label: "Data Agendamento",
          sortable: true,
          formatter: (value, key, sacAgendamentos) => {
            return moment(sacAgendamentos.dt_agendado)
              .add(3, "hours") // Adiciona 3 horas
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },
        {
          key: "filial_id",
          label: "Filial",
          sortable: true,
          formatter: (value) => (value ? value : ""),
        },
        { key: "id", label: "Nº Solicitação", sortable: true },
        {
          key: "solicitante_re",
          label: "Solicitante",
          sortable: true,
          formatter: (value) => (value ? value : ""),
        },
        {
          key: "solicitante_funcao",
          label: "Função",
          sortable: true,
          formatter: (value) => (value ? value : ""),
        },
        {
          key: "departamento",
          label: "Departamento",
          sortable: true,
          formatter: (value) => (value ? value : ""),
        },
        {
          key: "observacao",
          label: "Observação do solicitante",
          sortable: true,
          formatter: (value) => (value ? value : ""),
        },
        {
          key: "parecer",
          label: "Parecer do atendente",
          sortable: true,
          formatter: (value) => (value ? value : ""),
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          formatter: (value) => (value ? value : ""),
        },
        {
          key: "dt_cadastro",
          label: "Data cadastro",
          sortable: true,
          formatter: (value, key, sacAgendamentos) => {
            return moment(sacAgendamentos.dt_cadastro)
              .format("DD/MM/YYYY - HH:mm ")
              .replace("Data inválida", "-");
          },
        },

        // Outros campos...
        { key: "actions", label: "Atualizar" },
      ],

      //////// defeitos da corretiva

      tratativas: [
        {
          key: "status_id",
          label: "id Status",
          sortable: true,
          formatter: (value) => (value ? value : ""),
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          formatter: (value) => (value ? value : ""),
        },
        {
          key: "dt_agendamento",
          label: "Data Agendamento",
          sortable: true,
          formatter: (value, key, sacAgendamentoHorarios) => {
            return moment(sacAgendamentoHorarios.dt_agendamento)
              .format("DD/MM/YYYY - HH:mm ")
              .replace("Data inválida", "-");
          },
        },
        { key: "actions", label: "Agendar" },
      ],
    };
  },

  components: {
    Multiselect,
    LoadingModal,
  },
  methods: {
    loadFiliais() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: `${this.user.psg}`,
      };
      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios.get(url, { params }).then((res) => {
        this.filiais = res.data.map((filial) => {
          return { id_filial_erp: filial.id_filial_erp, filial: filial.filial };
        });
      });
    },

    loadStatus() {
      // Adicionando psg como parâmetro na query string
      const url = `${baseApiUrl}/sac/agendamento/status/${this.user.psg}`;

      axios
        .get(url)
        .then((res) => {
          // Processando os dados recebidos
          this.statuss = res.data.map((sta) => {
            return { ...sta, value: sta.id, status: sta.status };
          });
        })
        .catch((error) => {
          console.error("Erro ao carregar status:", error);
        });
    },

    loadHorarioAgenda() {
      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
        depto_id: `${this.sacAgendamento.depto_id}`,
        dt_agendamento: `${this.sacAgendamento.dt_agendado}`,
      };
      const url = `${baseApiUrl}/sac/agendamento/horario`;
      axios.post(url, corpo).then((res) => {
        this.sacAgendamentoHorarios = res.data;
      });
    },

    async loadDepartamentos() {
      let params = {
        origem: "agendamento",
        empresa_id: `${this.user.id_grupo_empresa}`,
        psg: `${this.user.psg}`,
      };
      const url = await `${baseApiUrl}/informatica/sac/departamento`;
      axios
        .get(url, { params })
        .then((res) => {
          this.departamentos = res.data.map((inte) => {
            return { ...inte, value: inte.id_area, area: inte.area }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    postAgendaFuncionario() {
      let corpo = {
        //"id_Agendamento": this.sacAgendamento.id_Agendamento ? `${this.sacAgendamento.id_Agendamento}`: this.idRetornoAgendamento,
        id:
          this.sacAgendamento.id !== ""
            ? `${this.sacAgendamento.id}`
            : `${this.idRetornoAgendamento}`,
        empresa_id: `${this.user.id_empresa}`,
        filial_id: `${this.user.id_filial_erp}`,
        depto_id: `${this.sacAgendamento.depto_id}`,
        operador_id: this.sacAgendamento.operador_id
          ? `${this.sacAgendamento.operador_id}`
          : `${this.funcionarios[0].id_funcionario_erp}`,
        dt_agendamento: `${this.sacAgendamento.dt_agendamento}`,
        funcionario_atendimento_id: `${this.user.id_funcionario_erp}`,
        observacao: `${this.sacAgendamento.observacao}`,
        status_id:
          this.sacAgendamento.id > 0 ? `${this.sacAgendamento.status_id}` : 1,
        parecer: `${this.sacAgendamento.parecer}`,
        psg: `${this.user.psg}`,
      };

      const url = `${baseApiUrl}/sac/agendamento/cad`;

      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          //this.loadSacSolicitacoesTratativas()
          this.getAgendaFuncionario();
          //this.postNotificacao()
          //this.reset() //limpar os objetos valores
        })
        .catch(showError);
    },

    getAgendaFuncionario() {
      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
        filial_id:
          this.value_filial && this.value_filial.length
            ? this.value_filial.map((a) => a.id_filial_erp).join(",")
            : `${this.user.id_filial_erp}`,
        status_id:
          this.value_status && this.value_status.length > 0
            ? this.value_status.map((r) => r.id).join(",")
            : null,
        depto_id:
          this.permissoes && this.permissoes.length > 0
            ? this.permissoes.map((p) => p.id_area).join(",")
            : null,
        psg: `${this.user.psg}`,
        origem: "web",
      };

      const url = `${baseApiUrl}/sac/agendamento/mov`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.sacAgendamentos = res.data;
        })
        .catch(showError);
    },

    async loadFuncionario() {
      let params = {
        registro: `${this.sacAgendamento.solicitante_re}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/folha/funcionario/busca`;
      axios.get(url, { params }).then((res) => {
        this.funcionarios = res.data;
      });
      //this.loadComprasFuncionario()
      //this.reset()
      //              this.loadNovoNroTicket()
    },

    /*
          axios.post(url,corpo)
              .then(res => { this.lavagens = res.data })        
              .catch(showError)    

*/

    loadAssunto() {
      let corpo = {
        origem: "app",
        empresa_id: `${this.user.id_grupo_empresa}`,
        depto_id: `${this.sacAgendamento.departamento_id}`,
      };
      const url = `${baseApiUrl}/informatica/sac/assunto`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.assuntos = res.data.map((inte) => {
            return { ...inte, value: inte.id_modulo, area: inte.modulo }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    loadMotivo() {
      let corpo = {
        origem: "app",
        empresa_id: `${this.user.id_grupo_empresa}`,
        modulo_id: `${this.sacAgendamento.assunto_id}`,
      };
      const url = `${baseApiUrl}/informatica/sac/motivo`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.motivos = res.data.map((inte) => {
            return { ...inte, value: inte.id, area: inte.motivo }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    handleCheckboxChange(value) {
      if (value === "true") {
        // Chame o método desejado aqui
        this.postSac();
      }
    },

    temporizador() {
      this.handle = setInterval(() => {
        this.barra_inicial = this.barra_inicial + 1000;
        if (this.barra_inicial >= this.barra_limite) {
          this.barra_inicial = 0;
          //this.loadSacSolicitacoes()
        }
      }, 1000);
    },

    loadEmpresas() {
      let corpo = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios.post(url, corpo).then((res) => {
        this.empresas = res.data.map((empresa) => {
          return {
            id_empresa: empresa.id_empresa,
            empresa: empresa.nomeempresarial,
          };
        });
      });
    },

    loadPermissao() {
      let params = {
        id_grupo: `${this.user.id_grupo}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/sac/permissao`;
      axios.get(url, { params }).then((res) => {
        this.permissoes = res.data.map((permissao) => {
          return { ...permissao, id_area: permissao.id_area };
        });
        this.getAgendaFuncionario();
      });
    },

    /*

        async loadPreventivasOsPecas() {      
            let corpo = {                    
                "os_erp": `${[this.preventivamonitoramento.os_erp]}`
            };

             const url = await `${baseApiUrl}/preventiva/pecas`                               
            axios.post(url,corpo).then(res => {                                
                this.carregando = false;
                this.loadPreventivasospecas = res.data                
            })            
        },
        */

    loadSacSolicitacoesTratativas() {
      let corpo = {
        id_Agendamento: `${[this.sacAgendamento.id_Agendamento]}`,
      };

      const url = `${baseApiUrl}/sac/solicitacoes/id`;
      axios.post(url, corpo).then((res) => {
        this.carregando = false;
        this.sacsolicitacoestratativa = res.data.map((sacT) => {
          return {
            id_Agendamento: sacT.id_Agendamento,
            dt_resposta: sacT.dt_resposta,
            id_respondido: sacT.id_respondido,
            respondido: sacT.respondido,
            registro: sacT.registro,
            justificativa: sacT.justificativa,
            id_status_leitura: sacT.id_status_leitura,
            status: sacT.status,
          };
        });
      });
    },

    loadAgendamentoFoto() {
      let params = {
        empresa_id: `${this.user.id_empresa}`,
        Agendamento_id:
          this.sacAgendamento.id_Agendamento != "undefined"
            ? `${this.sacAgendamento.id_Agendamento}`
            : null,
        origem: "consulta",
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/sac/solicitacoes_v2/arquivos`;
      axios.get(url, { params }).then((res) => {
        this.Agendamento = res.data;
      });
    },

    loadCarregaSac(sacAgendamentos) {
      this.sacAgendamento = { ...sacAgendamentos };
    },
    loadCarregaSacT(sacsolicitacoestratativa) {
      this.sacsolicitacoestratativa = { ...sacsolicitacoestratativa };
    },

    postSacTratativa() {
      let corpo = {
        //"id_Agendamento": this.sacAgendamento.id_Agendamento ? `${this.sacAgendamento.id_Agendamento}`: this.idRetornoAgendamento,
        id_Agendamento:
          this.sacAgendamento.id_Agendamento !== ""
            ? `${this.sacAgendamento.id_Agendamento}`
            : `${this.idRetornoAgendamento}`,
        justificativa: `${this.sacAgendamento.parecer}`,
        id_funcionario_resposta: `${this.user.id_funcionario}`,
        respondido_por: 1,
        origem: "Agendamento",
      };

      const url = `${baseApiUrl}/informatica/sac/lancamentostratativas`;

      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          //this.loadSacSolicitacoesTratativas()
          //this.loadSacSolicitacoes()
          //this.postNotificacao()
          //this.reset() //limpar os objetos valores
        })
        .catch(showError);
    },

    uptAvaliacao() {
      let corpo = {
        id_Agendamento:
          this.sacAgendamento.id_Agendamento !== ""
            ? `${this.sacAgendamento.id_Agendamento}`
            : `${this.idRetornoAgendamento}`,
        avaliacao: `${this.sacAgendamento.avaliacao}`,
      };

      const url = `${baseApiUrl}/informatica/sac/avaliacaoAgendamento`;

      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess();
        })
        .catch(showError);
    },

    reset() {
      this.idRetornoAgendamento = "";
      this.sacAgendamento.id_Agendamento = "";
      //this.parecer = ''
      //this.sacAgendamento.parecer = ''
      this.sacsolicitacoestratativa = [];
    },

    limparFiltro() {
      this.search = "";
    },
  },

  created() {
    this.loadPermissao();
    this.loadDepartamentos();
  },

  mounted() {
    this.loadFiliais();
    this.loadStatus();
    this.loadDepartamentos();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#selecaostatusx {
  font-size: 0.9em;
}

#re-nome {
  font-size: 0.9em;
}

#funcao {
  font-size: 0.9em;
}

#re-solicitante {
  font-size: 0.9em;
  font-style: inherit;
}

#parecer {
  font-size: 0.9em;
}

#rfilancamentos {
  font-size: 0.9em;
  text-align: center;
}

#resolicitante {
  font-size: 14px; /* Ajuste o tamanho da fonte conforme necessário */
}
</style>
